import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'dpl/common/design_system/Checkbox';
import Icon from 'dpl/common/components/Icon';

export default function ExpandableChecklist({
  checklistName,
  options,
  seeMoreAfter,
  onChange,
  values
}) {
  const [isShowingMore, setIsShowingMore] = useState(false);

  function renderOptionsComponent(opts) {
    return opts.map(opt => {
      if (opt.label) {
        return (
          <p key={opt.label} className="mb4 font-14 fw-medium">
            {opt.label}
          </p>
        );
      }

      const { title, value } = opt;

      return (
        <div key={value} className="mb4">
          <Checkbox
            key={value}
            id={`${checklistName}_${value}`}
            name={title}
            title={title}
            value={value}
            label={title}
            checked={values.includes(value)}
            onChange={onChange}
          />
        </div>
      );
    });
  }

  function renderShowMoreButton() {
    const [text, iconName] = isShowingMore
      ? ['Show less', 'fetch-chevron-up']
      : ['Show more', 'fetch-chevron-down'];

    return (
      <div className="flex items-center">
        <p className="stone-700 font-16 underline fw-medium">{text}</p>
        <Icon name={iconName} height="16px" />
      </div>
    );
  }

  const shouldShowMore = seeMoreAfter > 0 && seeMoreAfter < options.length;

  return (
    <div>
      {shouldShowMore ? (
        <>
          {renderOptionsComponent(options.slice(0, seeMoreAfter))}
          {isShowingMore && renderOptionsComponent(options.slice(seeMoreAfter))}
          <button
            type="button"
            onClick={() => setIsShowingMore(!isShowingMore)}
          >
            {renderShowMoreButton()}
          </button>
        </>
      ) : (
        renderOptionsComponent(options)
      )}
    </div>
  );
}

ExpandableChecklist.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired
      }),
      PropTypes.shape({ label: PropTypes.string }).isRequired
    ])
  ).isRequired,
  checklistName: PropTypes.string.isRequired,
  seeMoreAfter: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired
};

ExpandableChecklist.defaultProps = {
  seeMoreAfter: 0
};
